import '../App.css'
import Navbar from '../components/navbar.js'
import Footer from '../components/footer.js'
import { Carousel } from 'react-responsive-carousel'
import 'react-responsive-carousel/lib/styles/carousel.min.css'
import React, { useState } from 'react'
// import img1 from '../imagines/img1.webp';
import img2 from '../imagines/img2.webp';
import img3 from '../imagines/img3.webp';
import img4 from '../imagines/img4.webp';
import img5 from '../imagines/img5.webp';
import img6 from '../imagines/img6.webp';
import img7 from '../imagines/img7.webp';
import img8 from '../imagines/img8.webp';
import img9 from '../imagines/img9.webp';
import img10 from '../imagines/img10.webp';
import img11 from '../imagines/img11.webp';
import img12 from '../imagines/img12.webp';
import img13 from '../imagines/img13.webp';
import img14 from '../imagines/img14.webp';
import img15 from '../imagines/img15.webp';
import img16 from '../imagines/img16.webp';
import img17 from '../imagines/img17.webp';
import img18 from '../imagines/img18.webp';
import img19 from '../imagines/img19.webp';
import img20 from '../imagines/img20.webp';
import img21 from '../imagines/img21.webp';
import img22 from '../imagines/img22.webp';
import img23 from '../imagines/img23.webp';
import img24 from '../imagines/img24.webp';
import img25 from '../imagines/img25.webp';
import img26 from '../imagines/img26.webp';
import img27 from '../imagines/img27.webp';
import img28 from '../imagines/img28.webp';
import img29 from '../imagines/img29.webp';
// import img30 from '../imagines/img30.webp';
import img31 from '../imagines/img31.webp';
import img32 from '../imagines/img32.webp';
import img33 from '../imagines/img33.webp';
import img34 from '../imagines/img34.webp';
import img35 from '../imagines/img35.webp';
import img36 from '../imagines/img36.webp';
import img37 from '../imagines/img37.webp';
import img38 from '../imagines/img38.webp';
import img39 from '../imagines/img39.webp';
import img40 from '../imagines/img40.webp';
import img41 from '../imagines/img41.webp';
import img42 from '../imagines/img42.webp';



const images = [
  img2, img3, img4, img5, img6, img7, img8, img9, img10,
  img11, img12, img13, img14, img15, img16, img17, img18, img19, img20,
  img21, img22, img23, img24, img25, img26, img27, img28, img29,
  img31, img32, img33, img34, img35, img36, img37, img38, img39, img40,
  img41, img42
];


const Gallery = () => {
  const [currentImage, setCurrentImage] = useState(null);

  const openImage = (index) => {
    setCurrentImage(index);
  }
  const closeImage = () => {
    setCurrentImage(null);
  }
  return (
    <>
      <Navbar />
      <div className='gallery'>
          <div className ='title'>
              <h1><span className="font-letter">O</span>ur <span className="font-letter">G</span>allery</h1>
          </div>
          <div className='gallery-content'>
            {images.map((image, index) => (
              <div className='gallery-img-card' key={index} onClick={() => openImage(index)} loading='lazy'>
                <img src={image} alt={`Gallery index ${index + 1}`}/> 
              </div>
            ))}
          </div>
      </div>

      {currentImage != null && (
        <div className='image-modal' onClick={closeImage}>
          <span className='close' onClick={closeImage}>&times;</span>
          <div className='carousel-wrapper' onClick={e => e.stopPropagation()}>
            <Carousel showIndicators={false} showThumbs={false} showStatus={false} dynamicHeight={true} selectedItem={currentImage} infiniteLoop useKeyboardArrows>
              {images.map((image, index) => (
                <div key={index}>
                  <img src={image} alt={`Gallery index ${index + 1}`} />
                </div>
              ))}
            </Carousel>
          </div>
        </div>
      )}
      <Footer />
    </>
  )
}

export default Gallery